import React from 'react';
import {get} from 'lodash';
import moment from 'moment';
import axios from 'axios';

import ChatList from './ChatList';
import MessageList from './MessageList';
import UserWithImage from './UserWithImage';
import UserWithImageList from './UserWithImageList';
import {CSRF_TOKEN} from '../lib/helpers';

class Chat extends React.Component {
  state = {
    activeChatId: null,
    showMessageList: false,
    chats: []
  };

  _handlers = {
    onChangeActiveChatId: {},
  }

  onChangeActiveChatId = (activeChatId) => {
    let _handler = this._handlers.onChangeActiveChatId[activeChatId]

    if (!_handler) {
      _handler = () => {
        this.setState({activeChatId})
      }
    }

    return _handler
  }

  onLoadMore = (chats) => {
    this.setState({chats})
  }

  getActiveChat = () => {
    return get(this.state, 'chats', []).find((chat) => (
      chat.id == this.state.activeChatId
    ))
  };

  componentDidMount() {
    if (get(this.props, 'chats.length') < 1) {
      return
    }

    this.setState({
      activeChatId: get(this.props, 'chats[0].id'),
      showMessageList: true,
      chats: get(this.props, 'chats')
    })
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.activeChatId !== prevState.activeChatId) {
      axios.post(`/${gon.currentProvider}/api/chats/${this.state.activeChatId}/visit`, {
        authenticity_token: CSRF_TOKEN,
      })
    }
  }

  render() {
    return (
      <div className='Sidebar__wrapper Sidebar__wrapper--wide'>
        <div className='Sidebar SearchChat__wrapper'>
          <form
            className='Search'
            method='GET'
            action={`/${gon.currentProvider}/users/${get(this.props, 'userId')}/chats`}
          >
            <h3 className='Search__h3'>Use search tool for specific message</h3>

            <div className='Search__header'>
              <label className='Search__label Search__label--search'>Search</label>
              <a
                className='Search__header__a'
                href={`/${gon.currentProvider}/users/${get(this.props, 'userId')}/chats`}
              >
                Clear search
              </a>
            </div>
            <div className='User__search'>
              <input type='text' name='keyword' placeholder='Chat ID' />
              <button type='submit'>Search</button>
            </div>
          </form>

          {this.state.activeChatId !== null &&
            <ChatList
              activeChatId={this.state.activeChatId}
              onChangeActiveChatId={this.onChangeActiveChatId}
              onLoadMore={this.onLoadMore}
              chats={get(this.state, 'chats')}
              userId={get(this.props, 'userId')}
            />
          }
        </div>

        <div className='Main'>
          <ul className='Breadcrumb'>
            <li className='Breadcrumb__li'>
              <a
                className='Breadcrumb__a'
                href={`/${gon.currentProvider}/users`}
              >
                Users
              </a>
            </li>
            <li className='Breadcrumb__li'>
              <a
                className='Breadcrumb__a'
                href={`/${gon.currentProvider}/users`}
              >
                Users list
              </a>
            </li>
            <li className='Breadcrumb__li'>
              <a
                className='Breadcrumb__a'
                href={`/${gon.currentProvider}/users/${get(this.props, 'userId')}`}
              >
                User id {get(this.props, 'userId')}
              </a>
            </li>
            <li className='Breadcrumb__li'>
              Messages
            </li>
          </ul>

          {this.state.showMessageList &&
            <div className='Main__wrapper'>
              <div className='MainHeader'>
                <div className='MainHeader__left'>
                  <h2 className='MainHeader__h2'>Messages of user id {get(this.props, 'userId')}</h2>
                </div>

                <div className='MainHeader__right'>
                  <a
                    className='MainHeader__right__a MainHeader__right__a--switch'
                    href={`/${gon.currentProvider}/users/${get(this.props, 'userId')}/messages`}
                  >
                    Switch to messages view
                  </a>
                </div>
              </div>

              <div className='Messages'>
                <div className='Messages__header'>
                  <div className='Messages__header__left'>
                    <strong>Chatroom ID</strong> {this.state.activeChatId}
                    <strong>with users</strong>

                    {get(this.getActiveChat(), 'users.length') > 1 ?
                      <UserWithImageList users={get(this.getActiveChat(), 'users')}/>
                    :
                      <UserWithImage user={get(this.getActiveChat(), 'users[0]')}/>
                    }
                  </div>

                  <div className='Messages__header__right'>
                    <strong>Created at</strong> {moment(get(this.getActiveChat(), 'createdAt')).format('YYYY-MM-DD HH:mm')}
                  </div>
                </div>

                <MessageList
                  chat={this.getActiveChat()}
                  userId={get(this.props, 'userId')}
                />
              </div>
            </div>
          }
        </div>
      </div>
    );
  }
}

export default Chat
